export default __webpack_public_path__ + "static/logo-small-c636d6d7ac0a4c5762d01f5dde1d7c0e.png";